import { applyToAllStates } from '../../../theme/utils/form.utils';
export var textAreaTheme = {
  baseStyle: {
    container: {
      border: 'text-area.enabled',
      borderRadius: 'l',
      _active: {
        border: 'text-area.brand'
      },
      _hover: {
        border: 'text-area.hover'
      },
      '&[data-editable="false"]': applyToAllStates({
        border: 'text-area.disabled',
        color: 'neutral.darkest'
      }),
      _disabled: {
        border: 'text-area.disabled'
      },
      '&[data-readonly="true"]': applyToAllStates({
        cursor: 'default',
        border: 'text-area.readOnly'
      }),
      _invalid: applyToAllStates({
        border: 'text-area.error'
      })
    },
    field: {
      resize: 'none',
      padding: 's',
      width: '100%',
      borderRadius: 'l',
      textStyle: 'body2',
      overflow: 'auto',
      outlineColor: 'transparent',
      transition: 'outline-color 0.1s ease-in-out',
      _placeholder: {
        color: 'neutral.dark'
      },
      '&[data-editable="false"]': {
        color: 'neutral.darkest',
        textStyle: 'body4',
        cursor: 'default',
        _placeholder: {
          color: 'neutral.darkest',
          textStyle: 'body4'
        }
      },
      _readOnly: {
        cursor: 'default',
        _placeholder: {
          color: 'neutral.darker'
        }
      },
      _disabled: {
        cursor: 'not-allowed',
        color: 'neutral.light',
        backgroundColor: 'inherit',
        _placeholder: {
          color: 'neutral.light'
        }
      },
      _focusVisible: {
        outlineStyle: 'solid',
        outlineColor: 'focus.focus',
        outlineWidth: '2px',
        // This is done here with 4px instead of 2px because of the input-group that wraps the actual textarea element
        outlineOffset: '4px'
      }
    },
    footerContainer: {
      padding: 's',
      display: 'flex',
      alignItems: 'center'
    }
  }
};
//# sourceMappingURL=TextArea.theme.js.map